import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'SUPP_CLIENT',
  title: 'Come posso eliminare un cliente?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Sei libero di eliminare un\'azienda se non vuoi più condividere con essa i tuoi documenti. Devi solo seguire i passaggi qui sotto sulla tua piattaforma.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Vai alla scheda «Clienti».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SUPP_CLIENT/IT_SUPP_CLIENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Fare clic destro sui 3 punti di fronte al cliente.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SUPP_CLIENT/IT_SUPP_CLIENT_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Cliccando sui 3 punti si avrà la possibilità di eliminare l\'azienda.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SUPP_CLIENT/IT_SUPP_CLIENT_3.png`
  }]
};
